import { Component } from 'react';
import './styles.css';
import { SvgIcon } from 'components/Shared/SvgIcon';

const TERMS = `https://www.eduzz.com/termos-e-condicoes`;
const PRIVACY = `https://www.eduzz.com/politica-de-privacidade`;

interface IProps {
  size?: 'small' | 'large';
}

class Footer extends Component<IProps> {

  render() {
    return (
      <footer className="footer-root">
        {this.props.size !== 'small' && (
          <div className="footer-actions">
            <span role="button" onClick={() => window.open(PRIVACY)}>
              Políticas de privacidade
            </span>
            <span role="button" onClick={() => window.open(TERMS)}>
              Termos de uso
            </span>
          </div>
        )}

        <div className="footer-logo">
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a target="_blank" href="https://www.nutror.com/">
            <SvgIcon name='logoWithName' />
          </a>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a target="_blank" href="https://www.eduzz.com/">
            <label className="footer-logo-powered">Powered by Eduzz</label>
          </a>
        </div>
      </footer>
    );
  }
}

export default Footer;
